module.exports = __webpack_public_path__ + "media/images/hitfun/welcome.socials.telegram-7a2ca177bf6fc5d1715568d135c39f0b.png";